import { axiosDS } from '@pp/axios'
import { SimpleResponse } from 'Types/simpleResponse'
import { urls } from 'Constants/Urls'
import { ResponseCatalog, RequestParams } from 'Models'
import { PartnerContract, TContactFacesByPartner, TCreateContract } from 'Pages/pp'

export const contractsRegistryApi = {
	getAll: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<PartnerContract>>(
			urls.pp.contractsRegistry.contracts,
			{ params }
		)
		return res.data
	},
	getContractNumbers: async (like_contract_number: string) => {
		const res = await axiosDS().get<string[]>(urls.pp.contractsRegistry.contractNumbers, {
			params: { like_contract_number },
		})
		return res.data
	},

	set_status_partner: async (partner_id: number, status: string) => {
		const res = await axiosDS().patch<PartnerContract>(
			urls.pp.partner.status_partner
				.replace(':partner_id', String(partner_id))
				.replace(':status', status)
		)
		return res.data
	},

	create: async (contract: TCreateContract) => {
		const res = await axiosDS().post<PartnerContract>(urls.pp.contractsRegistry.contracts, {
			data: contract,
		})
		return res.data
	},
	delete: async (id: number) => {
		const res = await axiosDS().delete<SimpleResponse>(
			`${urls.pp.contractsRegistry.contracts}/${id}`
		)
		return res.data
	},
	update: async (contract: TCreateContract, id: number) => {
		const res = await axiosDS().patch<PartnerContract>(
			`${urls.pp.contractsRegistry.contracts}/${id}`,
			{
				data: contract,
			}
		)
		return res.data
	},
	massUpdate: async (contract: Partial<PartnerContract>, params: Record<string, unknown>) => {
		const res = await axiosDS().patch<SimpleResponse>(urls.pp.contractsRegistry.massUpdate, {
			...params,
			data: contract,
		})
		return res.data
	},
	getFaces: async (id: number) => {
		const res = await axiosDS().get<TContactFacesByPartner[]>(
			urls.pp.contractsRegistry.contactFaces.replace(':partner_id', String(id))
		)
		return res.data
	},

	createAstPartnerRequest: async (data: { partner_id: number; contract_id: number }) => {
		const res = await axiosDS().post<PartnerContract>(
			urls.pp.contractsRegistry.createAstPartnerRequests,
			{
				data,
			}
		)
		return res.data
	},

	limitRemainder: async (id: number) => {
		const res = await axiosDS().get<SimpleResponse>(
			urls.pp.contractsRegistry.notify_contract_limit_remainder.replace(':id', String(id))
		)
		return res.data
	},

	downloadLimitDocument: async (id: number) => {
		const res = await axiosDS().get<Blob>(
			urls.pp.contractsRegistry.download_limit.replace(':id', id.toString()),
			{
				responseType: 'blob',
			}
		)
		return res.data
	},
}
